import { render, staticRenderFns } from "./PersonalReferences.vue?vue&type=template&id=4a42cd97&"
import script from "./PersonalReferences.vue?vue&type=script&lang=js&"
export * from "./PersonalReferences.vue?vue&type=script&lang=js&"
import style0 from "./PersonalReferences.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a42cd97')) {
      api.createRecord('4a42cd97', component.options)
    } else {
      api.reload('4a42cd97', component.options)
    }
    module.hot.accept("./PersonalReferences.vue?vue&type=template&id=4a42cd97&", function () {
      api.rerender('4a42cd97', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/candidates/personal-references/PersonalReferences.vue"
export default component.exports